import React from 'react'
import { Link } from 'react-router-dom'
import { Markup } from 'interweave';
import classes from '../../App.module.css'

import noThumb from "../../images/no-thumb.jpg";

function MusicBox(music) {
    let thumb = null;
    if(music.thumb.includes('storage/media/thumbs/')) {
        thumb = `${process.env.REACT_APP_API_URL}/${music.thumb}`;
    }else {
        thumb = music.thumb;
    }
    
  return (
    <div className={classes.music}>
        <div className={classes.media}>
            <div className={classes.media_left}>
                <Link className={classes.media_thumb} to={`/video/${music.id}/${music.nice_url}`}>
                    <img src={thumb} onError={e => {e.target.src = noThumb}} alt={music.title} />
                </Link>
            </div>
            <div className={classes.media_body}>
                <div className={classes.media_info}>
                    <Link className={classes.song_title} to={`/video/${music.id}/${music.nice_url}`}>
                        <h4><Markup content={music.title} /></h4>
                    </Link>
                    <Link className={classes.uploader_link} to={`/profile/${music.user_id}/${music.username}`}>
                        <h6>{music.name}</h6>
                    </Link>
                </div>
                <div className={classes.meta}>
                    {
                        (music.duration > 0) && <h6 className={`m-0 ` + classes.media_duration}>{music.video_time}</h6>
                    }
                    <div className={classes.play_icon}>
                        <Link to={`/video/${music.id}/${music.nice_url}`}>
                            <i className="fa fa-play"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MusicBox